import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { InterCopmonentDataCarrierService } from '../../../../../services/inter-copmonent-data-carrier-service/inter-copmonent-data-carrier.service';
import { FeesService } from '../../services/fees.service';
import { FileDownloadService } from '../../../../../services/file-download-service/file-download.service';
import { FeeSummary } from '../../models/fee-summary';
import { AppSettings } from '../../../../../utils/app-settings';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { switchMap, filter } from 'rxjs/operators';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-mobile-fee-details',
  templateUrl: './mobile-fee-details.component.html',
  styleUrls: ['./mobile-fee-details.component.scss']
})
export class MobileFeeDetailsComponent extends ComponentBase implements OnInit {

  constructor(private interCopmonentDataCarrierService: InterCopmonentDataCarrierService
    , private feesService: FeesService
    , private iab: InAppBrowser
    , private cdRef: ChangeDetectorRef
    , private fileDownloadService: FileDownloadService) {
    super();
  }
  fee: FeeSummary;
  status: string;
  referenceNumber: string;
  amount: string;
  complete = false;
  public config: PerfectScrollbarConfigInterface = {};

  ngOnInit() {
    this.fee = this.interCopmonentDataCarrierService.retrieve("fee_item");
    this.interCopmonentDataCarrierService.delete("fee_item");
  }

  payNowClicked(fee: FeeSummary) {
    var browser;
    let sub = this.feesService.getPaymentUrl(fee.fee_payment_group_name)
      .pipe(
        switchMap(res => {
          let options: InAppBrowserOptions = { location: 'no', hardwareback: 'no', zoom: 'no', clearcache: 'yes', clearsessioncache: 'yes' };
          browser = this.iab.create(res, '_blank', options);
          return browser.on('loadstop');
        }),
        filter((event: any) => {
          return event.url.toLowerCase().includes('/feemanagement/billdesk/transactioncompletionstatus.aspx')
        })
      )
      .subscribe((event) => {
        browser.close();
        let url = new URL(event.url);
        this.complete = true;
        this.status = url.searchParams.get('s');
        this.referenceNumber = url.searchParams.get('ref');
        this.amount = url.searchParams.get('a');
        this.cdRef.detectChanges();
      });
    this.addSubscription(sub);
  }

  downloadReceipt(fee: FeeSummary) {
    let fee_payment_group_name_installment_date = fee.fee_payment_group_name ? fee.fee_payment_group_name : fee.installment_date.split('T')[0];
    let url = AppSettings.apiUrl + "fees/receipt/" + (fee_payment_group_name_installment_date);
    this.fileDownloadService.downloadAndOpen(url, "receipt.pdf", "application/pdf").subscribe();
  }

}
